const BackArrowDark = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4.16732 10L9.16732 5M4.16732 10L9.16732 15M4.16732 10H15.834"
      stroke="#D4D4D8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BackArrowDark;
